module.exports = require('./_global').document && document.documentElement;


//////////////////
// WEBPACK FOOTER
// ../wheelhouse-core/~/core-js/modules/_html.js
// module id = 107
// module chunks = 0